import React from "react";
import { useBuilder, BlockConfig } from "../BuilderContext";

const FooterBlock: React.FC<{ block: BlockConfig }> = ({ block }) => {
  const { state } = useBuilder();
  const heading = block.settings.headingOverride;

  return (
    <div className="py-4 border-t border-slate-200 mt-4">
      {heading && <p className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-2">{heading}</p>}
      <div className="text-xs text-slate-400 space-y-1">
        <p>{state.firm?.name}</p>
        {state.firm?.address && (
          <p>
            {[state.firm.address.line1, state.firm.address.city, state.firm.address.region, state.firm.address.postal]
              .filter(Boolean)
              .join(", ")}
          </p>
        )}
        <p className="italic mt-2">
          Funds held in trust are maintained in accordance with applicable Law Society regulations and are
          not property of the firm until properly disbursed.
        </p>
      </div>
    </div>
  );
};

export default FooterBlock;
